import React from 'react';

import { Box, Typography } from '@material-ui/core';

import blurBase64 from 'constants/blurBase64';

import GameIcon from 'components/@common/GameIcon';

interface Props {
  images: { url: string; alt: string }[];
}

const ImageGroup: React.FC<Props> = ({ images }) => {
  if (!images) {
    return null;
  }

  const hasMore = images.length > 4;
  const showcasedImages = hasMore ? [images[0], images[1], images[2]] : images;

  return (
    <Box display="flex" position="relative">
      {showcasedImages.map((image, key) => (
        <Box
          key={key}
          borderColor="white"
          border="2px solid"
          display="inline-flex"
          borderRadius="50%"
          zIndex={4 - key}
          ml={key > 0 ? -2 : 0}
        >
          <GameIcon
            size={32}
            src={image.url}
            alt={image.alt}
            mr={0}
            borderRadius="50%"
            imagesAboveFold
            blurDataURL={blurBase64}
          />
        </Box>
      ))}
      {hasMore && (
        <Box
          borderColor="white"
          border="2px solid"
          display="inline-flex"
          justifyContent="center"
          alignItems="center"
          borderRadius="50%"
          width="36px"
          height="36px"
          bgcolor="grey.400"
          ml={-2}
          color="white"
        >
          <Typography>{`+${images.length - 3}`}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ImageGroup;
